import { useSelector as reduxUserSelector } from 'react-redux';

import { IReduxState } from 'containers/App/reducer/types';

const useSelector = <Result = unknown>(
  selector: (state: IReduxState) => Result,
  equalityFn?: (left: Result, right: Result) => boolean
) => reduxUserSelector<IReduxState, Result>(selector, equalityFn);

export default useSelector;
